{/* <Slider
  getAriaLabel={() => 'Temperature range'}
  value={value}
  onChange={handleChange}
  valueLabelDisplay="auto"
  getAriaValueText={valuetext}
/> */}

import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';

// ----------------------------------------------------------------------

RHFRangePicker.propTypes = {
    name: PropTypes.string, onChange: PropTypes.any, value: PropTypes.any,
};
const Separator = styled('div')(
    ({ theme }) => `
    height: ${theme.spacing(3)};
  `,
  );
  function valuetext(value) {
    return `${value}°C`;
  }
  
export default function RHFRangePicker({ name, onChange, value, ...other }) {
    const { control, } = useFormContext();
    const [value1, setValue1] = React.useState([20, 37]);

    const handleChange1 = (event, newValue, activeThumb) => {
      if (!Array.isArray(newValue)) {
        return;
      }
  
      if (activeThumb === 0) {
        setValue1([Math.min(newValue[0], value1[1] - minDistance), value1[1]]);
      } else {
        setValue1([value1[0], Math.max(newValue[1], value1[0] + minDistance)]);
      }
    };
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <Slider
                // value={value1} 
                {...field} fullWidth error={!!error} helperText={error?.message} {...other}
                    getAriaLabel={() => 'Temperature range'}
                    // value={value1}
                    // onChange={handleChange1}
                    valueLabelDisplay="auto"
                    getAriaValueText={valuetext}
                />
                //   <TextField value={value} {...field} fullWidth error={!!error} helperText={error?.message} {...other} />
            )}
        />
    );
}
